import videoWebm from '../../../video/quai_antique.webm'
import videoMp4 from '../../../video/quai_antique.mp4'
import paths from '../../../config/paths'
import { useEffect } from 'react';



export default function Projects({ visited }) {

    useEffect(() => {
        visited();
    }, []);

    return(
        <main className="relative flex flex-col justify-evenly">
            <div className='video'>
                <video controls width="100%" height="100%" preload="true">
                    <source src={videoWebm} type="video/webm" />
                    <source src={videoMp4} type="video/mp4" />
                    <p>Votre navigateur ne prend pas en charge la vidéo.</p>
                </video>
            </div>
            <h2 className='title'>Quai Antique</h2>
            <p className='content'>ECF final avec une partie admin que j'ai faite entièrement qui permet de modifier le site et de voir les réservations.</p>
            <p className='skills'>HTML/CSS | Tailwind | Javascript | PHP | SQL | Symfony</p>
            <div className='project-button'>
                <a className='website' target="_blank" href="https://quai-antique.fr/">Le site</a>
                <a className='github' target="_blank" href="https://github.com/Coussecousse/quai_antique"><i className="fa-brands fa-github"></i>Github</a>
            </div>
            <div className='project-button big-buttons'>
                <a href={paths.CODEPEN} className='backProject'><i className="fa-solid fa-arrow-left mr-2"></i>Précédent projet</a>
                <a href={paths.PROJECTS} className='backProject'><i className="fa-solid fa-rotate-right mr-2"></i>Revenir aux projets</a>
                <a href={paths.CHARLES_CANTIN} className='backProject'>Prochain projet<i className="fa-solid fa-arrow-right ml-2"></i></a>
            </div>
        </main>
    )
}